// extracted by mini-css-extract-plugin
export default {"resetButton":"FZsAEqt","root":"SyeqtaL","sidebarColor":"VnpWgD0","borderLeft":"FXyhRnr","borderRight":"Yn9mR2r","content":"oUMSvDF"};